import { useEffect } from "react";
import { eduLevelsThunk } from "../../../../../../../store/redux/slice/AppData/eduLevels";
import { arUniEntryRequestConstantsThunk } from "../../../../../../../store/redux/slice/AppData/arUniEntryRequestConstants";
import useAppDispatch from "../../../../../../../hooks/redux/base/useAppDispatch";
import useAppSelector from "../../../../../../../hooks/redux/base/useAppSelector";
import { SelectFormField } from "@duosoftbg/nacid-components";

const ARUniEntryRequestRecognizedEduLevelSelectField = ({ fieldName, labelCode, required }) => {
  const dispatch = useAppDispatch();
  const eduLevelsThunkState = useAppSelector((state) => {
    return state.AppData.eduLevels;
  });

  const arUniEntryRequestConstants = useAppSelector((state) => {
    return state.AppData.arUniEntryRequestConstants;
  });

  useEffect(() => {
    dispatch(eduLevelsThunk());
    dispatch(arUniEntryRequestConstantsThunk());
  }, [dispatch]);

  return (
    <SelectFormField
      required={required}
      addEmptyOption={true}
      labelCode={labelCode}
      fieldName={fieldName}
      selectOptions={eduLevelsThunkState.data
        .filter(
          (edu) =>
            arUniEntryRequestConstants.data &&
            arUniEntryRequestConstants.data.allowedEduLevels &&
            arUniEntryRequestConstants.data.allowedEduLevels.filter((val) => val === edu.id).length > 0,
        )
        .map((edu) => {
          return { value: edu.id, text: edu.name, active: edu.isActive };
        })}
    />
  );
};
export default ARUniEntryRequestRecognizedEduLevelSelectField;
